export default {
  'customListGroup.title': 'Manage List Groups',
};
